import { z } from 'zod';

export const UserRole = z.enum(['ADMIN', 'STANDARD']);
export type UserRole = z.infer<typeof UserRole>;

export const UserRecord = z.object({
  id: z.string(),
  email: z.string().email(),
  displayName: z.string().nullable(),
  role: UserRole,
  disabled: z.boolean(),
  entraObjectId: z.string().nullable(),
  createdAt: z.string().datetime(),
  lastLoginAt: z.string().datetime().nullable(),
});
export type UserRecord = z.infer<typeof UserRecord>;

export const UserCreateRequest = z.object({
  email: z.string().email(),
  role: UserRole,
});
export type UserCreateRequest = z.infer<typeof UserCreateRequest>;

export const UserUpdateRequest = z
  .object({
    role: UserRole.optional(),
    disabled: z.boolean().optional(),
  })
  .refine((data) => data.role !== undefined || data.disabled !== undefined, {
    message: 'At least one of role or disabled must be provided',
  });
export type UserUpdateRequest = z.infer<typeof UserUpdateRequest>;

export const UserListResponse = z.object({
  items: z.array(UserRecord),
  total: z.number().int().nonnegative(),
  page: z.number().int().positive(),
  pageSize: z.number().int().positive(),
});
export type UserListResponse = z.infer<typeof UserListResponse>;
